import { get } from 'lodash';
import { fetch } from '@utils/utils';
import * as T from '@modules/tickets/_ticketsTypes';

export const getTicket = ({ addError }) => async (id: string): Promise<T.Ticket> => {
  try {
    const response: any = await fetch(`/metropolis/api/ed/tickets/${id}/dto`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });
    const json: T.Ticket = await response.json();
    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};
export const deleteTicket = ({ addError }) => async (id: string): Promise<T.Ticket> => {
  try {
    const response: any = await fetch(`/metropolis/api/ed/tickets/${id}`, {
      method: 'DELETE'
    });
    return response.ok;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

export const putTicket = ({ addSuccess, addError }) => async (body: T.Ticket): Promise<T.Ticket | null> => {
  try {
    const response: any = await fetch(`/metropolis/api/ed/tickets/${body.id}`, {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body)
    });
    if (response.ok) {
      const json: T.Ticket = await response.json();
      addSuccess('Blok byl úspěšně uložen');
      return json;
    } else {
      addError('Pri ukladaní došlo k chybe');
      return null;
    }
  } catch (err) {
    addError(err.message);
    return null;
  }
};

export const generateTickets = ({ addError, addSuccess }) => async (data: T.TicketsGenerator): Promise<boolean> => {
  try {
    const result = await fetch('/metropolis/api/ed/tickets/generate', {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      params: data
    });
    addSuccess();
    return result.ok;
  } catch (err) {
    addError(err.message);
    return false;
  }
};

export const cancelTickets = async ({ checkedItems }): Promise<boolean> => {
  try {
    const result = await fetch('/metropolis/api/ed/tickets/cancel', {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(checkedItems)
    });
    return result.ok;
  } catch (err) {
    return false;
  }
};

export const handOverTickets = async ({ checkedItems, ...data }): Promise<any> => {
  try {
    const response = await fetch('/metropolis/api/ed/tickets/hand-over-tickets', {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      params: data,
      body: JSON.stringify(checkedItems)
    });

    const result = await response.json();
    return result;
  } catch (err) {
    return [];
  }
};

export const getHandOverReportTemplate = async () => {
  try {
    const reportResponse = await fetch('/metropolis/api/reports/public?location=ticketPaymentRecord', {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const reports = await reportResponse.json();
    const template = reports[0];
    return template;
  } catch (err) {
    return null;
  }
};
export const getReportHandOver = async (template, reportData) => {
  try {
    const response = await fetch(`/metropolis/api/reports/${get(template, 'id')}/generate`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ record: reportData })
    });

    return response;
  } catch (err) {
    return null;
  }
};

export const moveTickets = async ({ checkedItems, employeeId }): Promise<boolean> => {
  try {
    const response = await fetch('/metropolis/api/ed/tickets/move', {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      params: { employeeId },
      body: JSON.stringify(checkedItems)
    });

    const result = await response.json();
    return result;
  } catch (err) {
    return false;
  }
};

export const getMoveReportTemplate = async () => {
  try {
    const reportResponse = await fetch('/metropolis/api/reports/public?location=ticketMoveReport', {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const reports = await reportResponse.json();
    const template = reports[0];
    return template;
  } catch (err) {
    return null;
  }
};
export const getReportMove = async (template, reportData) => {
  try {
    const response = await fetch(`/metropolis/api/reports/${get(template, 'id')}/generate`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ record: reportData })
    });

    return response;
  } catch (err) {
    return null;
  }
};

export const payBNPTicket = ({ addError }) => async ({ id, payDate, ...params }): Promise<boolean> => {
  try {
    const result = await fetch(`/metropolis/api/ed/tickets/${id}/pay-bnp`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      params: {
        payDate: `${payDate}:00.000Z`,
        ...params
      }
    });

    return result.ok;
  } catch (err) {
    addError(err.message);
    return false;
  }
};

export const payBNZTicket = ({ addError }) => async body => {
  try {
    const result = await fetch(`/metropolis/api/ed/tickets/pay-by-bnz`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body)
    });

    return result.ok;
  } catch (err) {
    addError(err.message);
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/modules/tickets/_ticketsActions.ts